import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { IconButton, ListItemText, Menu, MenuItem, Tooltip } from "@mui/material";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { Link as RouterLink } from "react-router-dom";
import { useState } from "react";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { FOLDERTREEMESSAGES } from "../../constants/messages";
import { GLOBALSETTINGS } from "../../data/constants";

const MyBreadcrumbs = () => {
  const breadcrumbs = useSelector((state: RootState) => state.breadcrumbs?.breadcrumbs ?? []);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const actualBreadcrumbs =
    Array.isArray(breadcrumbs) && breadcrumbs.length > 0
      ? breadcrumbs
      : [
          {
            id: -1,
            name: FOLDERTREEMESSAGES.ROOT_FOLDER,
            path: `${GLOBALSETTINGS.DEFAULT_PAGE}`,
          },
        ];

  const showMenu = actualBreadcrumbs.length > 4;
  const first = actualBreadcrumbs[0];
  const middle = actualBreadcrumbs.slice(1, actualBreadcrumbs.length - 2);
  const lastTwo = actualBreadcrumbs.slice(-2);

  return (
    <>
      <Breadcrumbs aria-label="breadcrumbs">
        {actualBreadcrumbs.length === 1 ? (
          <Typography key={first.id} className="active primary" color="text.primary">
            {first.name}
          </Typography>
        ) : (
          <Link component={RouterLink} to={first.path} underline="hover" color="inherit">
            {first.name}
          </Link>
        )}

        {showMenu && (
          <>
            <IconButton
              size="small"
              onClick={handleOpen}
              aria-controls="breadcrumb-menu"
              aria-haspopup="true"
            >
              <MoreHorizIcon fontSize="small" />
            </IconButton>

            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              id="breadcrumb-menu"
              aria-labelledby="with-menu-demo-breadcrumbs"
            >
              {middle.map((item) => (
                <MenuItem key={item.id} onClick={handleClose} component={RouterLink} to={item.path}>
                  <ListItemText>{item.name}</ListItemText>
                </MenuItem>
              ))}
            </Menu>
          </>
        )}

        {(showMenu ? lastTwo : actualBreadcrumbs.slice(1)).map((item, index, arr) =>
          index < arr.length - 1 ? (
            <Link
              key={item.id}
              component={RouterLink}
              to={item.path}
              underline="hover"
              color="inherit"
            >
              {item.name}
            </Link>
          ) : (
            <Tooltip key={item.id} title={item.name} placement="top" arrow>
              <Typography className="active primary breadcrumb-ellipsis" color="text.primary">
                {item.name}
              </Typography>
            </Tooltip>
          ),
        )}
      </Breadcrumbs>
    </>
  );
};

export default MyBreadcrumbs;
